import {isEmpty} from 'lodash';
import PropTypes from 'prop-types';
import {Component} from 'react';
import {push} from 'react-router-redux';
import {Button, Icon, Input, Select} from 'semantic-ui-react';
import actionCreators from '../actionCreators';
import connected from '../connected';
import ExclamationMark from '../images/exclamation_mark_circle.svg';
import {isNZLocale} from 'lib/PropertyUtils';

export class PropertySearchInput extends Component {
  static propTypes = {
    featureFlags: PropTypes.shape({
      rapidSearchEnabled: PropTypes.bool,
      nzRentalCma: PropTypes.bool,
      propertyPriceStatement: PropTypes.bool,
    }),
    propertySearch: PropTypes.object,
    value: PropTypes.string,
    open: PropTypes.bool,
    reportType: PropTypes.object.isRequired,
    onChange: PropTypes.func,
    dispatch: PropTypes.func.isRequired,
  };


  hasAddress = () => {
    const {propertySearch} = this.props;
    return !isEmpty(propertySearch.singleLineAddress);
  };

  options = () => {
    const {
      propertySearch,
      featureFlags: {rapidSearchEnabled = false, nzRentalCma = false, propertyPriceStatement = false} = {},
    } = this.props;
    const options = [
      {key: 1, text: 'Sales CMA', value: 'cma'},
      {key: 2, text: 'Rental CMA', value: 'rental'},
      {key: 3, text: propertyPriceStatement ? 'PPS' : 'SOI', value: 'soi'}
    ];

    if (isNZLocale()) {
      if (rapidSearchEnabled && nzRentalCma) {
        options.splice(2);
      } else {
        options.splice(1);
      }
    }
    else if (this.hasAddress() && !propertySearch.singleLineAddress.includes(' VIC ')) {
      options.splice(2);
    }
    return options;
  };

  onButtonClick = (event) => this.navigateToTargetProperty(event);

  onKeyDown = (event) => {
    const {propertySearch, open} = this.props;
    if (event.keyCode === 13 && !isEmpty(propertySearch.singleLineAddress) && !open) {
      this.navigateToTargetProperty(event);
    }
  };

  navigateToTargetProperty = (event) => {
    const {propertySearch, dispatch} = this.props;
    dispatch(push(`/properties/${propertySearch.propertyId}`));
    event.preventDefault();
  };

  changeReportType = (e, data) => {
    const {dispatch, reportType} = this.props;
    if (reportType.value !== data.value) {
      dispatch(actionCreators.chooseReportType(data.value));
    }
  };

  render() {
    const {reportType: {value: reportTypeValue}, value, featureFlags: {propertyPriceStatement = false} = {}} = this.props;
    return (
      <div>
        <Input type="text" placeholder="Search..." size="large" onKeyDown={this.onKeyDown}
               onChange={this.props.onChange} fluid>

          <input id="address-search-input" value={value} autoComplete="off"/>
          <Select id="report-type-select"
                  onChange={this.changeReportType}
                  disabled={!this.hasAddress()}
                  value={reportTypeValue}
                  options={this.options()}
                  icon={
                    <Icon name="chevron down"/>
                  }
          />
          <Button
            disabled={!this.hasAddress()}
            onClick={this.onButtonClick}
            size="huge"
            type="submit"
            primary
          >Create</Button>
        </Input>

        {reportTypeValue === 'soi' &&
        <div className="soi-hint-row">
          <img src={ExclamationMark} alt={propertyPriceStatement ? 'PPS warning' : 'SOI warning'}/>
          <div className="soi-hint-text">
            {propertyPriceStatement
              ? 'Property Price Statement documents available for Victorian properties only!'
              : 'Statement of information documents available for Victorian properties only!'}
          </div>
        </div>
        }

      </div>
    );
  }
}

export default connected(PropertySearchInput);
